import { Col, Row } from "reactstrap";
import ModalComponent from "../common/Modal/modal";
import { CustomButton } from "../../widgets";
import { useState, useRef, useEffect } from "react";
import ReactMarkdown from 'react-markdown';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

const ViewRecordSummary = (props) => {
     const { projectData, mdata } = props;
     const [selectedRecord, setselectedRecord] = useState<any>();
     const contentRef = useRef<HTMLDivElement>(null);

     const getViewData = (selected) => {
          let data = props;
          console.log(selected);
          setselectedRecord(selected);
     };

     const handleDownloadPDF = async () => {
          if (!contentRef.current) return;
      
          try {
              const original = contentRef.current;
      
              // Clone the content to avoid scroll issues
              const clone = original.cloneNode(true) as HTMLElement;
              clone.style.position = "absolute";
              clone.style.top = "0";
              clone.style.left = "-9999px";
              clone.style.width = `${original.scrollWidth}px`;
              clone.style.height = "auto";
              clone.style.overflow = "visible";
              document.body.appendChild(clone);
      
              await new Promise((resolve) => setTimeout(resolve, 200)); // Let styles apply
      
              const canvas = await html2canvas(clone, {
                  scale: 1,
                  useCORS: true,
                  allowTaint: true,
                  logging: false,
              });
      
              const imgData = canvas.toDataURL("image/png");
              const pdf = new jsPDF({
                  orientation: "portrait",
                  unit: "pt",
                  format: "a4",
              });
      
              const pageWidth = pdf.internal.pageSize.getWidth();
              const pageHeight = pdf.internal.pageSize.getHeight();
              const margin = 40;
              const usableWidth = pageWidth - margin * 2;
      
              const imgProps = {
                  width: canvas.width,
                  height: canvas.height,
              };
      
              const ratio = usableWidth / imgProps.width;
              const scaledHeight = imgProps.height * ratio;
              const availablePageHeight = pageHeight - margin * 2;
      
              let remainingHeight = scaledHeight;
              let position = 0;
      
              while (remainingHeight > 0) {
                  const canvasSliceHeight = Math.min(availablePageHeight / ratio, imgProps.height);
                  const sliceCanvas = document.createElement("canvas");
                  sliceCanvas.width = canvas.width;
                  sliceCanvas.height = canvasSliceHeight;
      
                  const ctx = sliceCanvas.getContext("2d");
                  ctx?.drawImage(
                      canvas,
                      0,
                      position / ratio,
                      canvas.width,
                      canvasSliceHeight,
                      0,
                      0,
                      canvas.width,
                      canvasSliceHeight
                  );
      
                  const sliceData = sliceCanvas.toDataURL("image/png");
                  const sliceHeight = (canvasSliceHeight * usableWidth) / canvas.width;
      
                  if (position > 0 && sliceCanvas.height > 5) {
                    pdf.addPage();
                    }
                
                    if (sliceCanvas.height > 5) {
                         pdf.addImage(sliceData, "PNG", margin, margin, usableWidth, sliceHeight);
                    }
                
               //    pdf.addImage(sliceData, "PNG", margin, margin, usableWidth, sliceHeight);
      
                  remainingHeight -= availablePageHeight;
                  position += availablePageHeight;
              }
      
              document.body.removeChild(clone);
              pdf.save("record-summary.pdf");
          } catch (err) {
              console.error("PDF Generation Error:", err);
          }
      };
      
     return (
          <>
               <div className="record-summary-container">
                    <div className="header-container">
                         <Row className='m-0'>
                              <Col className='pl-4 mt-3' md={11}>
                                   <div className='form-name'>{projectData?.topicdesc || projectData?.TopicDesc}</div>
                              </Col>
                              <Col className='pr-4 mt-3 text-right d-flex justify-content-between align-items-center' md={1}>
                                   <div className="download-icon-container">
                                        <i className='icon icon-download' onClick={handleDownloadPDF} />
                                   </div>
                                   <i className='icon icon-close' onClick={() => props.onClose()} />
                              </Col>
                         </Row>
                    </div>
                    <div className="record-summary-body" ref={contentRef}>
                         <div className="markdown-content">
                              <ReactMarkdown>{mdata}</ReactMarkdown>
                         </div>   
                    </div>
               </div>
          </>
     );
};

export default ViewRecordSummary;




